import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BulkActionsBar = ({ selectedCount, onAction, onClear }) => {
  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Icon name="CheckSquare" size={20} className="text-primary" />
          <span className="text-sm font-medium text-foreground">
            {selectedCount} user{selectedCount !== 1 ? 's' : ''} selected
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onAction('activate')}
            iconName="CheckCircle"
            iconPosition="left"
          >
            Activate
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onAction('suspend')}
            iconName="Ban"
            iconPosition="left"
          >
            Suspend
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onAction('send_invitation')}
            iconName="Mail"
            iconPosition="left"
          >
            Send Invitation
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClear}
            iconName="X"
            iconPosition="left"
          >
            Clear Selection
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;